import React, {useContext} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import { useTranslation } from "react-i18next";
import SecureFetchContext from 'context/SecureFetchContext';
import {
    Tooltip,makeStyles,
} from '@material-ui/core';
import getApiRoute from 'routes/apiRoutes';
import EditIcon from "@material-ui/icons/Edit";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import AppContext from 'context/AppContext';
import { SHIPPER_SHORTCUTS } from 'constants/shippers';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    root: {}
}));

export default function UpdateFuelDialog({  ...rest }) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [values, setValues] = React.useState({fuel: '', originalFuel: ''});
    const [feedback, setFeedback] = React.useState(null);
    const { t } = useTranslation();
    const secureFetch = useContext(SecureFetchContext);
    const { appValues } = useContext(AppContext);

    const selectedShipper = appValues.shippers.find((s) => s.id === values.shipper);
    const isPacketa = selectedShipper?.shortcut?.toUpperCase() === SHIPPER_SHORTCUTS.PACKETA;

    const handleChange = (event) => {
        setValues({
            ...values,
            [event.target.name]: event.target.value
        });
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setValues({fuel: '', originalFuel: ''});
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const payload = {
            shipper: values.shipper,
            fuel: String(values.fuel).replace(',', '.'),
        };
        if (isPacketa) {
            payload.originalFuel = String(values.originalFuel).replace(',', '.');
        }
        secureFetch(getApiRoute('admin_pricelist_fuel'), payload, 'POST').then(json => {
            const updated = Number(json?.updated ?? 0);
            setFeedback({
                severity: updated > 0 ? 'success' : 'warning',
                message: updated > 0
                    ? t('messages.fuel_updated', { count: updated })
                    : t('messages.fuel_updated_none'),
            });
            handleClose();
        });
    };

    return (
        <div>
            <Tooltip title={t('tooltip.update_fuel')} aria-label={t('tooltip.update_fuel')} onClick={handleClickOpen}>
                <Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    size="small"
                    startIcon={<EditIcon />}
                >
                    {t('button.update_fuel')}
                </Button>
            </Tooltip>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
            >
                <DialogTitle>{t('title.update_fuel')}</DialogTitle>
                <DialogContent>
                    <FormControl className={classes.formControl} fullWidth>
                        <InputLabel id="shipper">{t('label.shipper')}</InputLabel>
                        <Select
                            labelId="shipper"
                            value={ values.shipper || '' }
                            name="shipper"
                            onChange={handleChange}
                            required
                        >
                            {appValues.shippers.map((option) => (
                                <MenuItem
                                    key={option.id}
                                    value={option.id}
                                >
                                    {option.shortcut}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    {isPacketa && (
                        <TextField
                            fullWidth
                            label={t('label.original_fuel')}
                            name={"originalFuel"}
                            type="number"
                            onChange={handleChange}
                            value={values["originalFuel"] || ''}
                            inputProps={{ step: "any" }}
                            required
                        />
                    )}
                    <TextField
                        fullWidth
                        label={isPacketa ? t('label.new_fuel') : t('label.value')}
                        name={"fuel"}
                        type="number"
                        onChange={handleChange}
                        value={values["fuel"] || ''}
                        inputProps={{ step: isPacketa ? "any" : "1" }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="secondary">
                        {t('button.close')}
                    </Button>
                    <Button onClick={handleSubmit} color="primary" variant='contained'>
                        {t('button.edit')}
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar
                open={feedback !== null}
                autoHideDuration={5000}
                onClose={() => setFeedback(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => setFeedback(null)}
                    variant="filled"
                    severity={feedback?.severity || 'success'}
                >
                    {feedback?.message}
                </Alert>
            </Snackbar>
        </div>
    );
}
